var _ellipse, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.58581,
    rx: 7.5,
    ry: 7.33209,
    fill: "#FFCCC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.23431C5.14416 3.23431 3.23438 5.1441 3.23438 7.49994C3.23438 9.85578 5.14416 11.7656 7.5 11.7656C9.85584 11.7656 11.7656 9.85578 11.7656 7.49994C11.7656 5.1441 9.85584 3.23431 7.5 3.23431ZM2.01562 7.49994C2.01562 4.471 4.47106 2.01556 7.5 2.01556C10.5289 2.01556 12.9844 4.471 12.9844 7.49994C12.9844 10.5289 10.5289 12.9843 7.5 12.9843C4.47106 12.9843 2.01562 10.5289 2.01562 7.49994Z",
    fill: "#F5222D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55589 5.44405C9.79387 5.68202 9.79387 6.06786 9.55589 6.30583L6.30589 9.55583C6.06792 9.79381 5.68208 9.79381 5.44411 9.55583C5.20613 9.31786 5.20613 8.93202 5.44411 8.69405L8.69411 5.44405C8.93208 5.20607 9.31792 5.20607 9.55589 5.44405Z",
    fill: "#F5222D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44411 5.44405C5.68208 5.20607 6.06792 5.20607 6.30589 5.44405L9.55589 8.69405C9.79387 8.93202 9.79387 9.31786 9.55589 9.55583C9.31792 9.79381 8.93208 9.79381 8.69411 9.55583L5.44411 6.30583C5.20613 6.06786 5.20613 5.68202 5.44411 5.44405Z",
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.e57ab730.svg";
export { ForwardRef as ReactComponent };